/* unplugin-vue-components disabled */import script from "./Preview.vue?vue&type=script&setup=true&name=FilePreview&lang=js"
export * from "./Preview.vue?vue&type=script&setup=true&name=FilePreview&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=2552045b&lang=scss"

const __exports__ = script;

export default __exports__